export default __webpack_public_path__ + "static/predis-logo-h100px-499947bba7b2c01a08c62c4a234316a7.png";